export default {
  slug: "jetbrains-marketplace",
  code: "MP",
  label: "JetBrains Marketplace",
  shortLabel: "Marketplace",
  hideProductName: true,
  logoFamily: "marketplace",
};
